import React from 'react'

export function Header({ title }: { title: string }) {
  return <header className="rws-header">{title}</header>
}
